/**
 * `lines` - the OCR lines, from the text when the client kept no per-line
 * detail.
 *
 * Needs `text`. Provides `lines`. No options.
 */

import type { Step } from '../types.js';

export const linesStep: Step<Record<string, never>> = {
  name: 'lines',
  needs: () => ['text'],
  provides: () => ['lines'],
  async run(state) {
    if (state.input.lines?.length) return { added: [`${state.input.lines.length} lines, with the OCR engine's detail`] };
    const lines = (state.input.text ?? '').split(/\r?\n/).map((text) => text.trim()).filter(Boolean).map((text) => ({ text }));
    return { lines, added: [`${lines.length} lines, from the text`] };
  },
};
